import { Suborder } from 'shared/services/api/models/orders/suborder'

export const isNowPickupOrder = (subOrder: Suborder) =>
  typeof subOrder.carrier?.nowData?.slotPickup === 'object'
